export default "__VITE_ASSET__aaa7a9e1__"